export const CEX_ACCOUNT_COOLDOWN_PERIOD_MS = 3 * 7 * 24 * 60 * 60 * 1000;
export const SOCIAL_ACCOUNT_COOLDOWN_PERIOD_MS = 3 * 7 * 24 * 60 * 60 * 1000;
export const SOCIAL_ACCOUNT_MINIMUM_AGE_MS = 30 * 24 * 60 * 60 * 1000;
